import React, { useEffect } from "react";
import Categories from "../components/categories/Categories";
import FastDeliveryCard from "../components/fastDeliveryCard/FastDeliveryCard";
import LatestDiscountCouponCode from "../components/latestDiscountCouponCode/LatestDiscountCouponCode";
import PopularProduct from "../components/popularProduct/PopularProduct";
import OrganicProductCard from "../components/organicProductCard/OrganicProductCard.js";
import Slider from "../components/slider/Slider";
import LatestDiscountedProduct from "../components/latestDiscountedProduct/LatestDiscountedProduct";
import Cart from "../components/cart/Cart";
import { useFetchAllOffersQuery } from "../store/api/ProductSlice.js";
import SEO from "./SEO.js";
import AnnouncementPopup from "./AnnouncementPopup.js";

function Home() {
  const { data,error,isLoading } = useFetchAllOffersQuery();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="bg-gray-50">
      <AnnouncementPopup/>
        {/* ✅ SEO Meta Tags for Home Page */}
      <SEO
        title="Buy Nicotine Products Online | Fast Delivery & Trusted Brands – Pufframa"
        description="Shop nicotine pouches, gums, and oral products online at Pufframa. Fast delivery, discreet packaging, top brands, and a wide range of strengths and flavors. Adults 18+ only."
        image="https://pufframa.com/static/media/logo.44eaa8fdaa825d84dd29.png" 
        url="https://pufframa.com/"
        keywords="uy nicotine online, nicotine pouches, nicotine gum, oral nicotine, nicotine products India, discreet nicotine delivery,pufframa"
        structuredData={{
          "@context": "https://pufframa.com/",
          "@type": "WebSite",
          "name": "Pufframa",
          "url": "https://pufframa.com/",
          "potentialAction": {
            "@type": "SearchAction",
            "target": "https://pufframa.com/search?q={search_term_string}",
            "query-input": "required name=search_term_string"
          }
        }}
      />
      <div className="min-h-screen">
        <Cart />
        <div className="bg-white">
          <div className="mx-auto py-5 max-w-screen-2xl px-3 sm:px-10">
            <div className="flex w-full">
              <div className=" flex-shrink-0 xl:pr-6 lg:block w-full lg:w-3/5">
                <Slider />
              </div>
              <div className="w-full hidden lg:flex">
                <div className="w-full group">
                  <div className="bg-gray-50 h-full border-2 border-orange-500 transition duration-150 ease-linear transform group-hover:border-emerald-500 rounded shadow">
                    <div className="bg-orange-100 text-gray-900 px-6 py-2 rounded-t border-b flex items-center justify-center">
                      <h3 className="text-base  font-normal ">
                        Latest Super Discount Active Coupon Code
                      </h3>
                      
                    </div>
                    <div className="bg-green-100 text-gray-900 px-6 py-2 rounded-t border-b flex items-center justify-center">
                     <h3 className="text-base  font-bold ">
One Price, Double flavours                      </h3>
                    </div>

                  <div className="overflow-hidden">
  <div className="grid grid-cols-1 gap-4 max-w-2xl mx-auto">
    {[1].map((item, i) => (
      <div
        key={i}
        className="flex items-center bg-white rounded-lg shadow-md overflow-hidden"
      >
        {/* Left - Product Image */}
        <div className="w-1/2 p-4">
          <img
            src="https://api.pufframa.com/uploads/product-images/1752058618788-swft-pro-disposable-apple-peach-5-ApplePeach_72110339-bed3-4923-bc18-406f915225d0_600x.png" // Replace with your product image
            alt="Product"
            className="w-full h-auto object-contain"
                                        crossOrigin="anonymous"

          />
        </div>

        {/* Middle - Product Details */}
        <div className="w-1/2 px-4 py-4 space-y-1">
          <p className="text-sm text-red-500 font-semibold">41% Off</p>
          <p className="text-lg font-bold text-gray-800">
Swft Pro Disposable - Apple Peach 5%</p>
         
         <div className="flex items-center gap-3">
  {/* Sale Price */}
  <span className="text-xl font-bold text-green-600">
    $12.99
  </span>

  {/* Original Price */}
  <span className="text-sm text-gray-500 line-through">
    $21.99
  </span>

  {/* Discount Badge (Optional) */}

</div>

        </div>

        {/* Right - Price */}
       
      </div>
    ))}
  </div>
</div>

                  </div>
                </div>
              </div>
            </div>
            <OrganicProductCard />
          </div>
        </div>

        <Categories />

        <PopularProduct />
        <FastDeliveryCard />
        <LatestDiscountedProduct />
      </div>
    </div>
  );
}

export default Home;
